module.exports = __webpack_public_path__ + "static/media/friend-transfer-icon.317f1f03.svg";